export const kLocalServerPort = 3000;
export const kLocalClientPort = 9040;
export const kLocalHostname = "local.splice.com";
export const kLocalServerUrl = `https://${kLocalHostname}:${kLocalServerPort}`;
export const kLocalClientUrl = `https://${kLocalHostname}:${kLocalClientPort}`;
export const kProductionServerUrl =
    "https://v4gaxpidvnyfxmykvcsmitk2cu0hdrbk.lambda-url.us-west-1.on.aws";
export const kProductionClientUrl = "https://d2y593h9sdvflo.cloudfront.net";
export const kDevServerProxyPath = "/api-proxy";
export const kAtlantisApiUrl = "https://api.sessions.kits.ai";
export const kAtlantisApiUrlStaging = "https://atlantis-production-b916.up.railway.app"; // Atlantis STAGING API URL
// Splice's own GraphQL gateway, which owns the Stacks ("CoSo") create API. The
// gateway's CORS allowlist covers `*.splice.com` / `*.splice.fm` only, so Labs
// cannot call it from the iframe — every request goes through our server, which
// forwards the user's bearer token.
export const kSurfacesGraphqlUrl = "https://surfaces-graphql.splice.com/graphql";
export const kSurfacesGraphqlUrlStaging = "https://surfaces-graphql-preprod.splice.com/graphql";
